import { render, staticRenderFns } from "./AlertConfigurationAndNotification.html?vue&type=template&id=f008884c&scoped=true&external"
import script from "./AlertConfigurationAndNotification.js?vue&type=script&lang=js&external"
export * from "./AlertConfigurationAndNotification.js?vue&type=script&lang=js&external"
import style0 from "./AlertConfigurationAndNotification.scss?vue&type=style&index=0&id=f008884c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f008884c",
  null
  
)

export default component.exports